import { UserProfileService } from 'core/api/services/user';

const execute = async (props): Promise<void> => {
  return UserProfileService.editUserProfile(props).catch(error => console.error(error));
};

const LoadUserProfileUseCase = {
  execute,
};

export default LoadUserProfileUseCase;
